import cookies from "js-cookie";
import Vue from "vue";

let cache = null;

const session = {
  store({
    ID: id,
    Token: token,
    Username: username,
    Name: name,
    Group: group,
    GroupID: groupID,
    LastLogin: lastLogin,
    IDSekolah: idSekolah,
  }) {
    cookies.set("token", token);
    cookies.set("user", {
      id,
      username,
      groupID,
      group,
      lastLogin,
      name,
      idSekolah,
    });
  },

  get: {
    token() {
      return cookies.get("token");
    },
    user() {
      if (!cache) {
        try {
          const authJSON = cookies.get("user");
          cache = JSON.parse(authJSON);
        } catch (error) {
          return {};
        }
      }

      return cache;
    },
  },

  clear() {
    cache = null;
    cookies.remove("token");
    cookies.remove("user");
  },
};

Vue.prototype.$session = { ...session };

export default session;
